module.exports = __webpack_public_path__ + "media/images/editar_verde-3e1c1687809e38d713ac1be7f5b58ec2.svg";